//
//
//
//
//
//

import {
  PANEL_VARIANT_DEFAULT,
  PANEL_VARIANT_LIGHT,
} from '../../utils/constants'

export default {
  props: {
    variant: {
      type: String,
      default: PANEL_VARIANT_DEFAULT,
      validator: (value) =>
        [PANEL_VARIANT_DEFAULT, PANEL_VARIANT_LIGHT].includes(value),
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    panelClass() {
      const cls = []
      switch (this.variant) {
        case PANEL_VARIANT_LIGHT:
          cls.push('tw-bg-gray-50 tw-border tw-border-gray-200')
          break
        case PANEL_VARIANT_DEFAULT:
        default:
          cls.push('tw-bg-white tw-border tw-border-gray-200')
          break
      }
      if (!this.noPadding) {
        cls.push('tw-py-6 tw-px-4')
      }
      return cls
    },
  },
}
